import React, { useRef, useImperativeHandle } from 'react'
import { useTranslation } from 'react-i18next'
import { IFModal } from 'Components'
import PropTypes from 'prop-types'
import { OperatorUserProfile } from 'Containers'

const OperatorUserProfileModal = React.forwardRef(
  ({ setClickedOperatorUser }, ref) => {
    const { t } = useTranslation()
    const modalRef = useRef()

    const customDialogContentStyle = {
      height: '600px',
      width: '1000px',
    }

    const show = (rowData) => {
      if (rowData) setClickedOperatorUser(rowData)
      modalRef.current.show()
    }

    const dismiss = () => {
      modalRef.current.dismiss()
    }

    useImperativeHandle(ref, () => ({
      show,
      dismiss,
    }))

    return (
      <IFModal
        title={t('OperatorUserProfile.ModalTitle')}
        ref={modalRef}
        maxWidth={60}
        dialogContentStyle={customDialogContentStyle}
        onDismiss={() => setClickedOperatorUser({})}
      >
        <OperatorUserProfile />
      </IFModal>
    )
  },
)

OperatorUserProfileModal.propTypes = {
  setClickedOperatorUser: PropTypes.func,
}
export default OperatorUserProfileModal
